import Fire_base from '../../Config/Fire_base'


  const cekVerifStatus = async (currentUser) =>{
    
    if(currentUser){
        let currentuser =  Fire_base.auth().currentUser
        console.log(currentUser)
        await currentuser.sendEmailVerification().then(()=>alert("ok"))
        
    }

}

export default cekVerifStatus

